const name = 'options'

const ADD_OPTIONS = `${name}/ADD_OPTIONS`
const DELETE_OPTIONS = `${name}/DELETE_OPTIONS`
const UPDATE_OPTIONS = `${name}/UPDATE_OPTIONS`
const RESET_PRIVATE_OPTIONS = `${name}/RESET_PRIVATE_OPTIONS`

/*
 * Was `GET /api/public/options` ohne Anmeldung liefert — dieselbe Liste wie
 * `PUBLIC_OPTION_NAMES` im Backend (services/options/audience.js). Alles
 * andere kommt erst nach der Anmeldung (`loadPrivateOptions` in
 * shared/helpers) und geht beim Abmelden wieder aus dem Store.
 */
export const PUBLIC_OPTION_NAMES = ['branch', 'schoolTypes', 'typeOfOffers', 'genders', 'salutations']

const initialState = () => ({
	juniorInsurance: null,
	shareholderShares: null,
	branch: null,
	vatRateRevenues: null,
	vatRateExpenditure: null,
	schoolTypes: null,
	salutations: null,
	workAreas: null,
	typeOfOffers: null,
	shareAmounts: null,
	bankData: null,
	genders: null,
	reportsDeadline: null,
	invoicesOverdue: null,
	clearDBFile: null
})
export default function reducer(state = initialState(), action = {}) {
	const { payload } = action
	switch (action.type) {
		case ADD_OPTIONS: {
			return {
				...state,
				...payload.options
			}
		}
		case DELETE_OPTIONS: {
			return {
				...initialState()
			}
		}
		case RESET_PRIVATE_OPTIONS: {
			const oeffentlich = PUBLIC_OPTION_NAMES.reduce(
				(acc, key) => (key in state ? { ...acc, [key]: state[key] } : acc),
				{}
			)
			return {
				...initialState(),
				...oeffentlich
			}
		}
		case UPDATE_OPTIONS: {
			return {
				...state,
				...payload.options
			}
		}
		default: {
			return state
		}
	}
}

export const addOptions = options => {
	return {
		type: ADD_OPTIONS,
		payload: {
			options
		}
	}
}
export const updateOptions = options => {
	return {
		type: UPDATE_OPTIONS,
		payload: {
			options
		}
	}
}

// Beim Abmelden: nur die öffentlichen Einträge bleiben stehen.
export const resetPrivateOptions = () => ({ type: RESET_PRIVATE_OPTIONS })
